import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledExportTypeStep = styled('div')(
  () => css`
    .export-type-step-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
    }
  `
);

export const StyledExportTypeItem = styled('div')(
  ({ theme }) => css`
    padding: 16px;
    background: #ffffff;
    border: 1px solid ${theme.palette.gray.light};
    box-sizing: border-box;
    border-radius: 8px;
    cursor: pointer;
    overflow: hidden;
    font-weight: bold;
    font-size: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      border: 1px solid #aadbdd;
    }

    .format-item-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }

    .label {
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      text-align: center;
      width: 100%;
    }

    .format-title {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .label-title {
      white-space: nowrap;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      color: #0c395a;
    }

    .format-item-description {
      text-align: center;
      font-weight: 400;
      font-size: 12px;
      color: #3c607a;
      line-height: 24px;
    }
  `
);
